/**
 * Product Collection Vue component
 * ------------------------------------------------------------------------------
 * Main template in sections/index__featured-product-best-deals.liquid
 *
 * Collection products retrieved via Collections and Product Ajax API
 *
 */

import axios from 'axios'
import Cookies from 'js-cookie'

import VueTabs from '@/js/components/vue-tabs.vue'
import VueTab from '@/js/components/vue-tab.vue'
import KeenSlider from '@/js/components/keen-slider.vue'
import ProductItem from '@/js/components/product-item.js'

import { STOREFRONT_URL, storefrontRequestConfig } from '@/js/utils/api'
import { productQuery, transformGraphqlProduct } from '@/js/utils/data'

export default {
  components: {
    KeenSlider,
    VueTabs,
    VueTab,
    ProductItem
  },

  props: {
    collectionHandle: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      isLoading: true,
      collectionProducts: [],
      sliderOptions: {
        slides: {
          perView: 2.05,
          spacing: 4
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2,
              spacing: 16
            }
          },
          '(min-width: 1024px)': {
            slides: {
              perView: 2.5,
              spacing: 8
            }
          },
          '(min-width: 1280px)': {
            slides: {
              perView: 4.075,
              spacing: 4
            }
          }
        }
      }
    }
  },

  async created () {
    const collectionPromise = this._getCollectionProducts(this.collectionHandle)

    await Promise.all([collectionPromise]).then(data => {
      this.collectionProducts = data[0]
    }).catch(error => {
      console.log(error)
    })

    this.isLoading = false
  },

  methods: {
    _getCollectionProducts (collectionHandle) {
      const currentState = Cookies.get('state') || 'NSW' // used to filter products based on the available inventory in a location
      const data = `{
        collection(handle: "${collectionHandle}") {
          handle
          products(first: 250) {
            edges {
              node {
                ${productQuery}
              }
            }
          }
        }
      }`

      // eslint-disable-next-line no-undef
      return axios.post(STOREFRONT_URL, data, storefrontRequestConfig).then(({ data }) => {
        const products = data.data.collection.products.edges
        const filteredProducts = []

        products.forEach((product) => {
          let productItem = {}
          productItem = transformGraphqlProduct(product.node)
          const discountPercentage = Math.floor(((productItem.compare_at_price - productItem.price) / productItem.compare_at_price) * 100)

          // check if the current state value is ACT
          if (currentState === 'ACT') {
            // If the state is ACT, include products from both ACT and NSW warehouses
            if (discountPercentage > 81 && (productItem.available_on?.includes(currentState) || productItem.available_on?.includes('NSW'))) {
              filteredProducts.push(productItem)
            }
          } else {
            // check the state value (from the Cookie) and match if the selected state has an available inventory in the product
            if (discountPercentage > 81 && productItem.available_on?.includes(currentState)) {
              filteredProducts.push(productItem)
            }
          }
        })

        return filteredProducts
      }).catch((error) => {
        console.log('Best Deals section error:', error)
        throw error
      })
    }
  }
}
